import React, { useEffect, useState } from "react";
import "./Header.scss";
import { NavLink, useLocation } from 'react-router-dom';
import Navbar from "./Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === "/";
    const [isSticky, setIsSticky] = useState(false);

    // close menu when viewport becomes >= 768px (desktop)
    useEffect(() => {
        const mq = window.matchMedia("(min-width: 768px)");
        const handler = (e) => {
            if (e.matches) setIsMenuOpen(false);
        };
        if (mq.addEventListener) mq.addEventListener("change", handler);
        else mq.addListener(handler);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", handler);
            else mq.removeListener(handler);
        };
    }, []);

    // toggle sticky header after scrolling past threshold (home only)
    useEffect(() => {
        const threshold = 60; // pixels from top before header sticks
        const onScroll = () => {
            if (!isHome) {
                setIsSticky(false);
                return;
            }
            setIsSticky(window.scrollY > threshold);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, [isHome]);

    const closeMenu = () => setIsMenuOpen(false);
    const toggleMenu = () => setIsMenuOpen((s) => !s);
    return (
        <header className={`header ${isHome ? 'is-home' : ''} ${isHome && isSticky ? 'is-sticky' : ''}`}>
            <div className="navigation">
                <div className="brand">
                    <NavLink to="/" onClick={closeMenu} className='header-logo' aria-label="KayKo Designs - Home">
                        <img src="/images/kkd_logo_light.svg" alt="" onError={(e) => { e.currentTarget.src = 'https://storage.googleapis.com/kayko_design_portfolio/kkd_logo_light.svg'; }} />
                    </NavLink>
                </div>

                <button
                    className={`hamburger ${isMenuOpen ? "is-active" : ""}`}
                    aria-label="Toggle navigation"
                    aria-expanded={isMenuOpen}
                    aria-controls="main-navigation"
                    onClick={toggleMenu}
                >
                    <FontAwesomeIcon icon={isMenuOpen ? ['fas', 'times'] : ['fas', 'bars']} />
                </button>

                <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} closeMenu={closeMenu} />
            </div>
        </header >
    );
};

export default Header;